import React from 'react';
import PropTypes from 'prop-types';

/**
 * visible이 true인 경우 자식 컴포넌트가 표시된다.
 * @param {{visible: boolean, children: any }} props *
 * @returns
 */
const Visible = (props) => {
  const { visible = false, children } = props;
  if (visible == false) {
    return <></>;
  }

  return <>{children}</>;
};

Visible.propTypes = {
  visible: PropTypes.bool,
  children: PropTypes.node,
};

export default Visible;
